import { produce } from 'immer';
import { ISpecialOffer } from '../api/models/payment/eligible-categories.types';
import { initialRootState } from '../initialRootState';
import {
  EEligibleProductsActionType,
  IEligibleProductsAction,
} from './actions';
import { IBuyableProduct } from './types';

export interface IProductsState {
  products: IBuyableProduct[];
  currentSpecialOffer?: ISpecialOffer;
  currentSpecialOfferPaymentUrl?: string;
}

export const productsReducer = (
  currentState: IProductsState = initialRootState.products,
  action: IEligibleProductsAction
): IProductsState =>
  produce(currentState, draft => {
    switch (action.type) {
      case EEligibleProductsActionType.GET_SUCCESS:
        draft.products = action.payload.products;
        break;
    }
  });
